import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authEvents, userEvents } from '../../utils/analytics';
import Loader from '../../utils/Loader';
import './Form.css';

function SignupForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState('');

  const navigate = useNavigate();
  const { signupAndLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    // Clear previous errors
    setValidationError('');
    setError(null);

    // Basic validation
    if (password !== confirmPassword) {
      const msg = 'Passwords do not match';
      setValidationError(msg);
      userEvents.error('signup_validation', msg);
      return;
    }

    if (password.length < 6) {
      const msg = 'Password must be at least 6 characters long';
      setValidationError(msg);
      userEvents.error('signup_validation', msg);
      return;
    }

    setLoading(true);

    try {
      const user = await signupAndLogin(email, password);
      if (!user) throw new Error("Signup failed");
      authEvents.signup('email');
      userEvents.formSubmit('signup', true);
      navigate("/account", { replace: true });
    } catch (err) {
      console.error("Signup error:", err);
      const msg = err.response?.data?.detail ||
                 err.response?.data?.message ||
                 err.message ||
                 "Signup failed. Please try again.";
      setError(msg);
      userEvents.formSubmit('signup', false);
      userEvents.error('signup', msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-section component-card">
      <h2 className="subtitle">Create Account</h2>
      <p className="text">Join Read The Tape to start generating newsletters</p>
      <form onSubmit={handleSubmit} className="form">
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        {validationError && (
          <div className="error-message">
            {validationError}
          </div>
        )}
      
      <div className="form-group">
        <label htmlFor="signup-email">Email</label>
        <input
          type="email"
          id="signup-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          disabled={loading}
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="signup-password">Password</label>
        <input
          type="password"
          id="signup-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
          disabled={loading}
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="signup-confirm-password">Confirm Password</label>
        <input
          type="password"
          id="signup-confirm-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm your password"
          required
          disabled={loading}
          className="form-input"
        />
      </div>

      <button 
        type="submit" 
        className="login-signup-button btn-primary"
        disabled={loading}
      >
        {loading ? (
          <Loader size="small" text="Creating account..." />
        ) : (
          'Create Account'
        )}
      </button>
    </form>
    </div>
  );
}

export default SignupForm;
